"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHideShowOptions = void 0;
var react_1 = require("react");
var useHideShowOptions = function (options) {
    if (options === void 0) { options = {}; }
    var broadcastShowOptions = options.broadcastShowOptions;
    var _a = (0, react_1.useState)(false), showOptions = _a[0], setShowOptions = _a[1];
    var handleHideOptions = function () {
        setShowOptions(false);
    };
    var handleShowOptions = function () { return setShowOptions(true); };
    var isFirstMount = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(function () {
        !isFirstMount.current && broadcastShowOptions && broadcastShowOptions(showOptions);
    }, [showOptions]);
    (0, react_1.useEffect)(function () { isFirstMount.current = false; }, []);
    return { showOptions: showOptions, handleHideOptions: handleHideOptions, handleShowOptions: handleShowOptions };
};
exports.useHideShowOptions = useHideShowOptions;
